export default __webpack_public_path__ + "static/media/triumpf.a9ef0400.svg";